$(document).ready(function () {

    $(window).scroll(scrollCheck);
    scrollCheck();

    function scrollCheck() {
        if (window.pageYOffset > 10) {
            $('body').addClass('scrolled');
        } else {
            $('body').removeClass('scrolled');
        }
    }

});
